import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import Section from '../../components/layout/Section';
import PageTitle from '../../components/UI/PageTitle';
import TableWrapper from './TableWrapper';
import PageNavigation from '../../components/UI/PageNavigation';
import MainBody from '../../components/layout/MainBody';
import Button from '../../components/UI/Button';
import { useFetch } from '../../hooks/useFetch';
import { boardApi } from '../../api/board';

const BoardContainer = styled.div`
	width: 900px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 100px;
	align-items: center;
`;

export default function Board() {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const isAuthenticated = useSelector((state) => state.user.isAuthenticated );

	const currentPage = parseInt(searchParams.get('page')) || 1;

	const { data, loading, error } = useFetch(boardApi.getPosts, [currentPage]); 

	if (loading) return ;

	if(error) {
		alert('게시글을 불러오는 도중에 오류가 발생했습니다.');
		navigate('/');
		return ;
	}

	const totalPage = data ? data.totalPages : 1;

	const onClickPage = (page) => {
		if(page < 1 || page > totalPage) return;
		navigate(`/board?page=${page}`);
	};

	const onClickWrite = () => {
		// 로그인 하지 않은 경우 alert 후 로그인 페이지로 이동
		if(!isAuthenticated) {
			alert('로그인이 필요합니다.');
			navigate('/log-in');
			return;
		}

		navigate('/board/form');
	}

  	return (
		<MainBody>
			<Section>
				<BoardContainer>
					<PageTitle style = {{ border: 'none' }}>주문제작 및 문의사항 게시판</PageTitle>
					<TableWrapper data={ data.posts }/>
					<Button 
						onClick={ onClickWrite } 
						buttonText="글쓰기"
						style={{ alignSelf: 'flex-end', cursor: 'pointer' }}
						width="100px"
						height="40px"
						textSize="16px"
					/>
					<PageNavigation
						totalPage={totalPage}
						currentPage={currentPage}
						onPageChange={onClickPage}
						style={{ marginTop: '20px'}}
					/>
				</BoardContainer>
			</Section>
		</MainBody>
  	);
}
